import axios from 'axios';
import authHeader from '../auth-header';
import tokenHeader from '../token-header';
import baseUrl from '../base-url';

const API_URL = baseUrl() + '/api/all/';

const getKarir = 'karir';
const postKarir = 'karir';
const putKarir = 'karir/';
const deleteKarir = 'karir/';

class KarirService {

    getKarir(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getKarir + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            }
        )
    }

    postKarir(request) {        
        var form = new FormData();
        form.append('position', request.position);
        form.append('description', request.description);
        form.append('status', request.status);

        if(typeof request.flyer !== 'undefined') {
            form.append('flyer', request.flyer);
        }

        if(typeof request.file !== 'undefined') {
            form.append('file', request.file);
        }

        return axios
            .post(API_URL + postKarir, form, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': tokenHeader()
                }
            })
            .then(response => {
                return response.data.message;
            });
    }

    putKarir(request) {
        var form = new FormData();        
        form.append('position', request.position);
        form.append('description', request.description);
        form.append('status', request.status);

        if(typeof request.flyer !== 'undefined') {
            form.append('flyer', request.flyer);
        }

        if(typeof request.file !== 'undefined') {
            form.append('file', request.file);
        }

        return axios
            .put(API_URL + putKarir + request.idKarir, form, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': tokenHeader()
                }
            });
    }

    deleteKarir(request) {
        return axios.delete(API_URL + deleteKarir + request.idKarir, {
            headers: authHeader()
        });
    }

}

export default new KarirService();